import { AxiosInstance } from 'axios'
import { CustomBlockContent, Localizations } from '../types'

export type NewsDetailsDto = {
  data: {
    id: number
    attributes: NewsDetailsAttributes
  }[]
}

export interface NewsDetailsAttributes {
  localizations: Localizations
  title: string
  short_text: string
  image?: MediaObject
  slug?: string
  publicated_at: string // ISO date
  content?: CustomBlockContent
  type: 'Our Press' | "Seline's HomePageNews"
  createdAt: string // ISO timestamp
  updatedAt: string // ISO timestamp
  publishedAt: string // ISO timestamp
}

export interface MediaObject {
  data: {
    id: number
    attributes: {
      name: string
      alternativeText: string | null
      caption: string | null
      width: number
      height: number
      hash: string
      ext: string
      mime: string
      size: number
      url: string
      previewUrl: string | null
      provider: string
      createdAt: string // ISO timestamp
      updatedAt: string // ISO timestamp
    }
  }
}

export type GetNewsDetailsArgs = {
  locale: string
  slug: string
}

export const getNewsDetails = async (client: AxiosInstance, { locale, slug }: GetNewsDetailsArgs) => {
  const path = `/news`
  const params = {
    locale,
    fields: ['title', 'short_text', 'slug', 'type', 'createdAt', 'updatedAt', 'publishedAt', 'publicated_at'],
    populate: {
      localizations: {
        fields: ['locale', 'slug'],
      },
      image: {
        populate: '*',
      },
      content: {
        populate: '*',
      },
    },
    filters: {
      slug: {
        $eq: slug,
      },
    },
  }
  return (await client.get<NewsDetailsDto>(path, { params })).data.data[0].attributes
}
